import { render, staticRenderFns } from "./MfImageBox.vue?vue&type=template&id=2846f69d&scoped=true&"
import script from "./MfImageBox.vue?vue&type=script&lang=js&"
export * from "./MfImageBox.vue?vue&type=script&lang=js&"
import style0 from "./MfImageBox.vue?vue&type=style&index=0&id=2846f69d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846f69d",
  null
  
)

export default component.exports